<template>
    <b-modal id="modal-view-employee" ref="modal-view-employee" title="Información del empleado" no-enforce-focus scrollable size="lg">
      <b-row class="justify-content-center">
        <b-col>
          <img :src="`${employeeSelected['user.pathAvatar']},tr=w-300`"  width="150" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/>
        </b-col>
      </b-row>
      <b-row class="m-auto">
        <a-divider> Información del empleado </a-divider>
        <b-col v-for="(value, key) in fieldsToShow" v-bind:key="key.id" v-show="employeeSelected[key]" lg="6" md="15" sm="15">>
          <b>{{ value }}:</b> {{ employeeSelected[key] }}
        </b-col>
      </b-row>
      <b-row class="m-auto">
        <a-divider> Contrato del empleado </a-divider>
        <b-col v-for="(value, key) in contractToShow" v-bind:key="key.id" v-show="employeeContract[key]" :lg="(value === 'Observaciones') ? 12 : 6" md="15" sm="15">>
          <b>{{ value }}:</b> {{ employeeContract[key] }}
        </b-col>
      </b-row>
      <template #modal-footer="{ hide }">
        <b-button variant="secondary" @click="hide('modal-view-employee')">
          Cerrar
        </b-button>
      </template>
    </b-modal>
</template>

<script>
import axios from 'axios'
import apiClient2 from '@/services/axios/v2.js'
import { currencyFormatPesos } from '@/services/utilities'
import moment from 'moment'

export default {
  name: 'ModalViewEmployee',
  props: {
    idEmployee: Number,
  },
  data() {
    return {
      fieldsToShow: {
        'user.cc': 'Identificación del empleado',
        idIdentificationType: 'Tipo de identificación',
        fullName: 'Nombre del empleado',
        'user.email': 'Correo electronico',
        idDepartment: 'Departamento',
        idMunicipality: 'Municipio',
        idPaymentMethod: 'Metodo de pago',
        idBankAccountType: 'Tipo de cuenta',
        bankAccountNumber: 'Número de cuenta',
        idBank: 'Banco',
        idEps: 'EPS',
        idPensionFund: 'Fondo de pensiones',
        idSeveranceFund: 'Fondo de cesantias',
        idCompensationBox: 'Caja de compensación',
      },
      contractToShow: {
        jobPosition: 'Cargo',
        idContractType: 'Tipo de contrato',
        workStartDate: 'Fecha de inicio',
        workEndDate: 'Fecha de finalización',
        idEmployeeType: 'Tipo de trabajador',
        idEmployeeSubType: 'Subtipo de trabajador',
        salary: 'Salario',
        idPaymentPeriod: 'Frecuencia de pago',
        riskLevel: 'Nivel de riesgo',
        hasFullSalary: 'Salario integral',
        hasHighRisk: 'Es de alto riesgo',
        deactivationDate: 'Fecha de terminación de contrato',
        causeOfWithdrawal: 'Motivo de la terminación',
        observations: 'Observaciones',
      },
      toSearchWhereTo: {
        idIdentificationType: 'identificationOptions',
        idDepartment: 'departments',
        idMunicipality: 'municipalities',
        idPaymentMethod: 'paymentMethods',
        idBankAccountType: 'bankAccountTypes',
        idBank: 'banks',
        idEps: 'healths',
        idPensionFund: 'pensions',
        idSeveranceFund: 'severances',
        idCompensationBox: 'boxes',
        idContractType: 'contracts',
        idPaymentPeriod: 'paymentPeriods',
        idEmployeeType: 'typesEmployee',
        idEmployeeSubType: 'subTypesEmployee',
        hasHighRisk: 'riskLevel',
        hasFullSalary: 'riskLevel',
      },
      identificationOptions: [],
      departments: [],
      municipalities: [],
      paymentMethods: [],
      bankAccountTypes: [
        { text: 'Ahorros', value: '1' },
        { text: 'Corriente', value: '2' },
      ],
      banks: [],
      healths: [],
      paymentPeriods: [],
      pensions: [],
      severances: [],
      boxes: [],
      typesEmployee: [],
      subTypesEmployee: [],
      contracts: [],
      riskLevel: [
        { text: 'Si', value: true },
        { text: 'No', value: false },
      ],
      employeeSelected: {},
      employeeContract: {},
    }
  },
  created() {
    axios.all([
      this.getIdentifications(), this.getDepartments(), this.getTypesContract(),
      this.getPaymentPeriod(), this.getTypesEmployee(), this.getSubTypesEmployee(),
      this.getPaymentMethods(), this.getBanks(), this.getEps(), this.getPension(),
      this.getSeverances(), this.getBoxes()])
      .then(axios.spread((identifications, departments, contracts, paymentPeriods, typesEmployee, subTypesEmployee, paymentMethods, banks, healths, pensions, severances, boxes) => {
        this.setDataIdentificationTypes(null, identifications.data)
        this.setDepartments(null, departments.data)
        this.setContractTypes(null, contracts.data)
        this.setPaymentPeriods(null, paymentPeriods.data)
        this.setTypesEmployee(null, typesEmployee.data)
        this.setSubTypesEmployee(null, subTypesEmployee.data)
        this.setPaymentMethods(null, paymentMethods.data)
        this.setBanks(null, banks.data)
        this.setEps(null, healths.data)
        this.setPensions(null, pensions.data)
        this.setSeveranceFunds(null, severances.data)
        this.setBoxes(null, boxes.data)
      }))
  },
  methods: {
    currencyFormat: function (money) {
      return currencyFormatPesos(money)
    },
    getEmployee() {
      return new Promise((resolve, reject) => {
        apiClient2.get('/employees/' + this.idEmployee).then(async (res) => {
          const keys = Object.keys(res.data.data)
          await apiClient2.get(`municipalities/${res.data.data.idDepartment}`).then((res) => {
            this.municipalities = res.data.data.map((x) => {
              return {
                value: x.id,
                text: x.name,
              }
            })
          }).catch()
          for (const key of keys) {
            this.employeeSelected[key] = res.data.data[key]
            if (this[this.toSearchWhereTo[key]] && res.data.data[key]) {
              const hasThingie = this[this.toSearchWhereTo[key]].find((data) => data.value === res.data.data[key].toString())
              if (hasThingie) {
                this.employeeSelected[key] = hasThingie.text
              }
            }
          }
          const fields = ['firstName', 'secondName', 'firstLastName', 'secondLastName']
          let fullName = ''
          for (const name of fields) {
            fullName += `${res.data.data['user.' + name]} `
          }
          this.employeeSelected.fullName = fullName.trim()
          this.employeeSelected = { ...this.employeeSelected }
          resolve()
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getContractEmployee() {
      return new Promise((resolve, reject) => {
        apiClient2.get(`/employees/${this.idEmployee}/contracts`).then((res) => {
          const contracts = res.data.data
          if (contracts.length > 0) {
            const keys = Object.keys(contracts[0])
            for (const key of keys) {
              this.employeeContract[key] = contracts[0][key]
              if (this[this.toSearchWhereTo[key]] && (contracts[0][key] || typeof contracts[0][key] === 'boolean')) {
                const hasThingie = (typeof contracts[0][key] === 'boolean')
                  ? this[this.toSearchWhereTo[key]].find((data) => data.value === contracts[0][key])
                  : this[this.toSearchWhereTo[key]].find((data) => data.value === contracts[0][key].toString())
                if (hasThingie) {
                  this.employeeContract[key] = hasThingie.text
                }
              }
            }
            const dates = ['workStartDate', 'workEndDate', 'deactivationDate']
            for (const key of dates) {
              this.employeeContract[key] = (this.employeeContract[key])
                ? moment(this.employeeContract[key]).format('DD-MM-YYYY')
                : this.employeeContract[key]
            }
            this.employeeContract.salary = currencyFormatPesos(Number(this.employeeContract.salary))
            this.employeeContract = { ...this.employeeContract }
          }
          resolve()
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getIdentifications() {
      return apiClient2.get('/types-identification')
    },
    getDepartments() {
      return apiClient2.get('/departments')
    },
    getTypesContract() {
      return apiClient2.get('/types-contracts')
    },
    getPaymentPeriod() {
      return apiClient2.get('/payment-periods')
    },
    getTypesEmployee() {
      return apiClient2.get('/types-employees')
    },
    getSubTypesEmployee() {
      return apiClient2.get('/subtypes-employees')
    },
    getPaymentMethods() {
      return apiClient2.get('/payment-methods')
    },
    getBanks() {
      return apiClient2.get('/banks')
    },
    getEps() {
      return apiClient2.get('/eps')
    },
    getPension() {
      return apiClient2.get('/pension-funds')
    },
    getSeverances() {
      return apiClient2.get('/severance-funds')
    },
    getBoxes() {
      return apiClient2.get('/compensation-boxes')
    },
    setDataIdentificationTypes (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.identificationOptions = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
    setDepartments (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.departments = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
    setMunicipalities (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.municipalities = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
    setContractTypes (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.contracts = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
    setPaymentPeriods (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.paymentPeriods = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
    setTypesEmployee (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.typesEmployee = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
    setSubTypesEmployee (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.subTypesEmployee = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
    setPaymentMethods (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.paymentMethods = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
    setBanks (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.banks = data.data.map((x) => {
          return {
            value: x.id.toString(),
            text: x.name,
          }
        })
      }
    },
    setEps (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.healths = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
    setPensions (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.pensions = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
    setSeveranceFunds (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.severances = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
    setBoxes (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.boxes = data.data.map((x) => {
          return {
            value: x.id,
            text: x.name,
          }
        })
      }
    },
  },
  watch: {
    idEmployee: function (value) {
      if (value) {
        this.getEmployee()
          .then(() => this.getContractEmployee())
          .catch((error) => {
            console.error('Ha ocurrido un error:', error)
          })
      }
    },
  },
}

</script>
